<template>
  <div class="my-team" v-title data-title="团队管理">
    <header>
      <div class="content-top">
        <!-- 时间选项 -->
        <img src="../../assets/images/partner-img/partner-information/19.png" alt="" class="icon">

        <div class="date-option" @click="showPopup">
          <span>
            {{status_hierarchy}}<img src="../../assets/images/partner-img/partner-information/16.png" alt="">
          </span>
        </div>
        <p class="statistics">
          <span>
            共：{{team_list.number}}人
          </span>
        </p>
      </div>
    </header>
    <section>
      <div class="share-option-list" v-for="(item,index) in team_list.list" :key="index">
        <div class="share-option-list-content">
          <div class="touxiang">
            <img :src="item.avatar" alt="">
          </div> 
          <div class="msg1">
            <span>
              {{item.user_nickname}}
            </span>
            <span>
              {{item.create_time}}
            </span>
          </div>
          <div class="msg2">
            <span>
              <img src="../../assets/images/partner-img/partner-information/20.png" alt="" class="icon">
              间接邀请
              {{item.inviter_count}}人
            </span>
            <span>
              <!-- 二级佣金 -->
            </span>
          </div>
        </div>
      </div>
    </section>
    <van-action-sheet 
      v-model="show" 
      :actions="actions" 
      @select="onSelect" 
      :close-on-click-action="true"
    />
  </div>
</template>

<script>

import Vue from 'vue';
import { DatetimePicker, Popup, ActionSheet } from 'vant';

Vue.use(ActionSheet);
Vue.use(DatetimePicker);
Vue.use(Popup);

export default {
  data() {
    return {
      actions: [
        { name: '消费者', id: 1}, 
        { name: '会员', id: 2 },
        { name: '商家', id: 3 }, 
        { name: '合伙人', id: 4 }
      ],
      show: false,
      team_list: [], // 佣金列表
      status_hierarchy : '身份等级', // 选择时间
      uid : ''
    };
  },
  created(){
    // 佣金
    this.uid = JSON.parse(localStorage.getItem("uid"));
    this.$axios.post(this.domain.url+"/api/user/index/myTeam",{
      uid : this.uid,
    }).then((res) => {
      // console.log(res.data.data)
      this.team_list = res.data.data
    })
  },
  methods: {
    showPopup(){
      this.show = true
    },
    onSelect(item) {
      // 默认情况下点击选项时不会自动收起
      // 可以通过 close-on-click-action 属性开启自动收起
      this.show = false;
      this.status_hierarchy = item.name
      this.search_identity = item.id
      this.$axios.post(this.domain.url+"/api/user/index/myTeam",{
        uid : this.uid,
        type : this.search_identity,
      }).then((res) => {
        console.log(res.data.data)
        this.team_list = res.data.data
      })
    },
  },
}
</script>

<style lang="less" scoped>
  .my-team{
    width: 7.5rem;
    display: flex;
    flex-direction: column;
    background: #f4f4f4;
    header{
      .content-top{
        width: 7.5rem;
        height: 1.29rem;
        overflow: hidden;
        .icon{
          width: .34rem;
          height: .34rem;
          float: left;
          margin-top: .46rem;
          margin-left: .3rem;
        }
        .date-option{
          background: #fff;
          border-radius: .24rem;
          margin-top: .4rem;
          margin-left: .2rem;
          float: left;
          font-size: 0.26rem;
          font-family: PingFang SC;
          font-weight: 500;
          color: #212121;
          text-align: center;
          line-height: .26rem;
          padding: .12rem .12rem .12rem .21rem;
          img{
            width: .07rem;
            height: .05rem;
            margin-bottom: .1rem;
            margin-left: .1rem;
          }
        }
        .statistics{
          float: right;
          font-size: 0.24rem;
          font-family: PingFang SC;
          font-weight: 500;
          color: #A1A1A1;
          margin-right: .12rem;
          span{
            display: block;
            &:first-child{
              line-height: 1.29rem;
            }
          }
        }
      }
    }
    section{
      .share-option-list{
        width: 7.1rem;
        margin: 0 auto;
        background: #fff;
        display: flex;
        align-items: center;
        .share-option-list-content{
          width: 6.85rem;
          height: 1.68rem;
          background: #fff;
          margin: 0 auto;
          border-bottom: .01rem #EDEDEF solid;
          .touxiang{
            width: .94rem;
            height: 1.68rem;
            float: left;
            margin-right: .1rem;
            display: flex;
            align-items: center;
            img{
              width: .94rem;
              height: .94rem;
              border-radius: 50%;
            }
          }
          .msg1{
            float: left;
            span{
              display: block;
              &:first-child{
                font-size: 0.3rem;
                line-height: .3rem;
                font-family: PingFang SC;
                font-weight: 500;
                color: #222222;
                margin-top: .46rem;
              }
              &:last-child{
                font-size: 0.24rem;
                line-height: .24rem;
                font-family: PingFang SC;
                font-weight: 500;
                color: #919191;
                margin-top: .18rem;
              }
            }
          }
          .msg2{
            height: 1.68rem;
            float: right;
            display: flex;
            align-items: center;
            span{
              display: block;
              &:first-child{
                font-size: 0.24rem;
                font-family: PingFang SC;
                font-weight: 500;
                color: #212121;
                img{
                  width: .27rem;
                  height: .26rem;
                }
              }
              &:last-child{
                font-size: 0.2rem;
                line-height: .2rem;
                font-family: PingFang SC;
                font-weight: 500;
                color: #FF6600;
                margin-top: .1rem;
              }
            }
          }
        }
      }
    }
  }
</style>